/* eslint-disable max-lines */
import {
  getLink,
  getLinkHref,
  getBrowseLink,
  getLinkPath,
  getSpecialClassesLink,
  getSpecialClassesLinkHref,
  getSpecialClassesAllLink,
  getTopicLink,
  getTopicLinkHref,
  getTopicListLink,
  getTopicListHref,
  getHrefAndAsOfAFreeCourse,
  getHrefAndAsOfSaved,
  getPannerLink,
  getGtpFreeClassesAllLink,
  getYoutubeCourseLink,
  getYoutubeLessonLink
} from '@models/Topology';
import {
  getLinkPath as courseLinkPath,
  getLink as courseLink
} from '@models/Course';
import { getFullName } from '@api/hooks/utils';
import { getStringWordsJoinedWith } from './textHelper';

export const getClass = (item = {}, isGTP) => {
  const { programme = {} } = item;
  const { goal, name: courseName } = programme;
  if (!goal) return [];
  if (item.isSpecial || item.programme?.isSpecial) {
    const tags = [
      {
        title: goal.name,
        as: getLink(goal),
        href: getLinkHref()
      }
    ];

    tags.push(
      isGTP
        ? {
            title: 'Free Classes',
            ...getGtpFreeClassesAllLink(goal)
          }
        : {
            title: 'Free classes & tests',
            as: getSpecialClassesLink(goal),
            href: getSpecialClassesLinkHref()
          }
    );

    return tags;
  }
  const tags = [
    {
      title: goal.name,
      as: getLink(goal),
      href: getLinkHref()
    }
  ];

  if (!isGTP) {
    tags.push({
      title: courseName,
      as: courseLink(programme),
      href: courseLinkPath(programme)
    });
  }

  return tags;
};

export const getDoubtSolutionsHomeTags = (
  goal,
  // eslint-disable-next-line no-unused-vars
  ctlgData = null,
  // eslint-disable-next-line no-unused-vars
  ctlgItemData = null,
  isOfflineSubscription = null
) => {
  if (!goal) return;
  const title = isOfflineSubscription ? 'Centre' : 'Plus';
  return [
    {
      title: goal.name,
      as: getLink(goal),
      href: getLinkHref()
    },
    {
      title,
      as: getLink(goal),
      href: getLinkHref()
    }
  ];
};

export const getCatalogueQuetionsHomeTag = (
  goal,
  ctlgData,

  // eslint-disable-next-line no-unused-vars
  ctlgItemData = null,
  isOfflineSubscription = null
) => {
  if (!goal) return;
  const { ctlgSlug, ctlgUID, ctlgTitle } = ctlgData;
  const title = isOfflineSubscription ? 'Centre' : 'Plus';
  return [
    {
      title: goal.name,
      as: getLink(goal),
      href: getLinkHref()
    },
    {
      title,
      as: getLink(goal),
      href: getLinkHref()
    },
    {
      title: 'Doubt Solving',
      as: `${getLink(goal)}/doubts-and-solutions/`,
      href: `${getLinkHref()}/doubts-and-solutions/`
    },
    {
      title: ctlgTitle,
      as: `${getLink(goal)}/doubts-and-solutions/${ctlgSlug}/${ctlgUID}`,
      href: `${getLinkHref()}/doubts-and-solutions/[catalogSlug]/[catalogUID]`
    }
  ];
};

export const getCatalogueDetailsHomeTags = (
  goal,
  // eslint-disable-next-line no-unused-vars
  ctlgData = null,
  // eslint-disable-next-line no-unused-vars
  ctlgItemData = null,
  isOfflineSubscription = null
) => {
  if (!goal) return;
  const title = isOfflineSubscription ? 'Centre' : 'Plus';
  return [
    {
      title: goal.name,
      as: getLink(goal),
      href: getLinkHref()
    },
    {
      title,
      as: getLink(goal),
      href: getLinkHref()
    },
    {
      title: 'Doubts & solutions',
      as: `${getLink(goal)}/doubts-and-solutions/`,
      href: `${getLinkHref()}/doubts-and-solutions/`
    }
  ];
};

const getPlusTopicsTags = (goal, isOfflineSubscription = null) => {
  if (!goal) return;
  const title = isOfflineSubscription ? 'Centre' : 'Plus';
  return [
    {
      title: goal.name,
      as: getLink(goal),
      href: getLinkHref()
    },
    { title, as: getLink(goal), href: getLinkHref() }
  ];
};

const getPlatformBatchTopicsTags = (goal) => {
  if (!goal) return [];
  return [
    {
      title: goal.name,
      as: getLink(goal),
      href: getLinkHref()
    }
  ];
};

const getBatchTags = (goal, isOfflineSubscription = null, isStoreRoute) => {
  if (!goal) return;
  const title = isOfflineSubscription ? 'Centre' : 'Plus';
  const as = getLink(goal);
  const href = getLinkHref();
  return isStoreRoute
    ? [
        {
          title: goal.name,
          as: `${as}/store`,
          href: `${href}/store`
        },
        { title: 'Batches', as: `${as}/store`, href: `${href}/store` }
      ]
    : [
        {
          title: goal.name,
          as,
          href
        },
        { title, as, href },
        { title: 'Batches', as: `${as}/batches`, href: `${href}/batches` }
      ];
};

const getYoutubeLessonTags = (goal, data) => {
  if (!goal) return;
  return [
    {
      title: goal.name,
      ...getYoutubeCourseLink(data)
    },
    {
      title: 'Free courses',
      ...getYoutubeCourseLink(data)
    },
    {
      title: data.playlistName,
      ...getYoutubeLessonLink(data)
    }
  ];
};

const getYoutubeCourseTags = (goal) => {
  if (!goal) return;
  return [
    {
      title: goal.name,
      as: `${getLink(goal)}`,
      href: `${getLinkHref()}`
    },
    {
      title: 'Free courses',
      ...getYoutubeCourseLink({ goalUID: goal.uid })
    }
  ];
};

const getGoalAndFreeTagsOfFreeTopic = (goal) => {
  if (!goal) return;
  return [
    {
      title: goal.name,
      as: getLink(goal),
      href: getLinkHref()
    },
    {
      title: 'Free courses',
      as: `${getLink(goal)}/free-platform`,
      href: `${getLinkHref()}/free-platform`
    }
  ];
};

const getGoalTopicsTitle = (goal, isGTP) => {
  if (goal.isNoTestGoal) return 'Key concepts';
  if (isGTP) return 'Video lessons';
  return 'Syllabus';
};

const getTopics = (goal, isGTP = false) => {
  if (!goal) return;
  return [
    {
      // eslint-disable-next-line no-nested-ternary
      title: getGoalTopicsTitle(goal, isGTP),
      as: `${getLink(goal)}/topics`,
      href: `${getLinkHref()}/topics`
    }
  ];
};

const getTopologyTags = (topology, goal) => {
  if (!topology || !goal) return;
  return [
    {
      title: topology.name,
      as: getTopicLink(topology, goal),
      href: getTopicLinkHref()
    }
  ];
};

const getEducatorTag = (author, educatorUsername) => {
  if (!author) return;
  return [
    {
      title: getFullName(author.firstName, author.lastName),
      as: `/@${educatorUsername}`,
      href: '/[authorID]'
    }
  ];
};

const getCourseTags = (goal, topicGroup, isOfflineSubscription = null) => {
  if (!goal) return [];
  const title = isOfflineSubscription ? 'Centre' : 'Plus';
  const Tags = [
    {
      title: goal.name,
      as: getLink(goal),
      href: getLinkHref()
    },
    { title, as: getLink(goal), href: getLinkHref() }
  ];
  if (topicGroup) {
    Tags.push(
      {
        title: 'Syllabus',
        as: getTopicListLink(goal),
        href: getTopicListHref()
      },
      {
        title: topicGroup.name,
        as: getTopicLink(topicGroup, goal),
        href: getLinkPath()
      }
    );
  }
  return Tags;
};

export const getFreeCourseTags = (goal, topologies) => {
  if (!goal?.uid) return [];
  const { href, as } = getHrefAndAsOfAFreeCourse(goal);
  const Tags = [
    {
      title: goal.name,
      href,
      as
    },
    {
      title: 'Free courses',
      href,
      as
    }
  ];
  if (topologies?.parent?.parent) {
    Tags.push({
      title: topologies.parent.parent.name,
      as: `/goal/${goal.goalSlug}/${goal.uid}/free-platform/${
        topologies.parent.parent.slug ||
        getStringWordsJoinedWith(topologies.parent.parent.name, '-')
      }/${topologies.parent.parent.uid}`,
      href: '/goal/[goalSlug]/[goalUID]/free-platform/[topicSlugType]/[topicSlugUID] '
    });
    Tags.push({
      title: topologies.parent.name,
      as: `/goal/${goal.goalSlug}/${goal.uid}/free-platform/${
        topologies.parent.parent.slug ||
        getStringWordsJoinedWith(topologies.parent.parent.name, '-')
      }/${
        topologies.parent.slug ||
        getStringWordsJoinedWith(topologies.parent.name, '-')
      }/${topologies.parent.uid}`,
      href: '/goal/[goalSlug]/[goalUID]/free-platform/[topicSlugType]/[topicSlugUID]/[conceptUID] '
    });
  }
  return Tags;
};

const getTestSeriesTags = (goal, isOfflineSubscription = null) => {
  if (!goal) return [];
  const title = isOfflineSubscription ? 'Centre' : 'Plus';
  return [
    {
      title: goal.name,
      as: getLink(goal),
      href: getLinkHref()
    },
    { title, as: getLink(goal), href: getLinkHref() },
    {
      title: 'Test series',
      href: '/goal/[goalSlug]/[goalUID]/test-series',
      as: `/goal/${goal.slug}/${goal.uid}/test-series`
    }
  ];
};

const getPlatformSeeAllTags = (
  seeAllType,
  goal,
  topicGroup,
  hasSubscription = true,
  pageType,
  isOfflineSubscription = null
) => {
  let seeAllLinks = null;
  const title = isOfflineSubscription ? 'Centre' : 'Plus';
  if (seeAllType === 'specialClass') {
    seeAllLinks = [
      {
        title: goal.name,
        as: getLink(goal),
        href: getLinkHref(goal)
      },
      {
        title: 'Free classes & tests',
        ...getSpecialClassesAllLink(goal)
      }
    ];
    return seeAllLinks;
  }
  if (seeAllType === 'goal' && !hasSubscription) {
    if (
      [
        'educators',
        'batches',
        'upcoming',
        'recently_started',
        'popular_courses'
      ].includes(pageType)
    ) {
      seeAllLinks = [
        {
          title: goal.name,
          as: getLink(goal),
          href: getLinkHref(goal)
        }
      ];
      return seeAllLinks;
    }
  }
  if (seeAllType === 'goal' || seeAllType === 'enrolled') {
    seeAllLinks = [
      {
        title: goal.name,
        ...getBrowseLink(goal)
      },
      {
        title,
        ...getBrowseLink(goal)
      }
    ];
    return seeAllLinks;
  }
  if (seeAllType === 'freeCourses') {
    seeAllLinks = [
      {
        title: goal.name,
        as: getLink(goal),
        href: getLinkHref(goal)
      },
      {
        title: 'Free',
        ...getHrefAndAsOfAFreeCourse(goal)
      }
    ];
    return seeAllLinks;
  }

  return [
    {
      title: goal.name
    },
    {
      title
    },
    {
      title: 'Syllabus',
      as: getTopicListLink(goal),
      href: getTopicListHref()
    },
    {
      title: topicGroup.name,
      href: getTopicLink(topicGroup, goal),
      as: getLinkPath()
    }
  ];
};

const getSeeAllTags = (
  seeAllType,
  goal,
  topicGroup,
  hasSubscription = true,
  pageType,
  isGTP,
  isOfflineSubscription
) => {
  const title = isOfflineSubscription ? 'Centre' : 'Plus';
  let seeAllLinks = null;
  if (seeAllType === 'enrolledBatches') {
    seeAllLinks = [
      {
        title: goal.name,
        ...getPannerLink(goal)
      }
    ];
    return seeAllLinks;
  }
  if (seeAllType === 'specialClass') {
    seeAllLinks = [
      {
        title: goal.name,
        as: getLink(goal),
        href: getLinkHref(goal)
      }
    ];

    seeAllLinks.push(
      isGTP
        ? {
            title: 'Free Classes',
            ...getGtpFreeClassesAllLink(goal)
          }
        : {
            title: 'Free classes & tests',
            ...getSpecialClassesAllLink(goal)
          }
    );
    return seeAllLinks;
  }
  if (seeAllType === 'goal' && !hasSubscription) {
    if (
      [
        'educators',
        'batches',
        'upcoming',
        'recently_started',
        'popular_courses'
      ].includes(pageType)
    ) {
      seeAllLinks = [
        {
          title: goal.name,
          as: getLink(goal),
          href: getLinkHref(goal)
        },
        {
          title: 'Browse',
          as: `${getLink(goal)}/browse`,
          href: `${getLinkHref(goal)}/browse`
        }
      ];
      return seeAllLinks;
    }
  }
  if (seeAllType === 'goal' || seeAllType === 'enrolled') {
    seeAllLinks = [
      {
        title: goal?.name || '',
        ...getBrowseLink(goal)
      },
      {
        title,
        ...getBrowseLink(goal)
      }
    ];
    return seeAllLinks;
  }
  if (seeAllType === 'freeCourses') {
    seeAllLinks = [
      {
        title: goal?.name || '',
        as: getLink(goal),
        href: getLinkHref(goal)
      },
      {
        title: 'Free',
        ...getHrefAndAsOfAFreeCourse(goal)
      }
    ];
    return seeAllLinks;
  }
  if (seeAllType === 'enrolledCourses') {
    seeAllLinks = [
      {
        title: goal?.name || '',
        ...getBrowseLink(goal)
      },
      {
        title,
        ...getBrowseLink(goal)
      },
      {
        title: 'Enrolled',
        href: `${getLinkHref()}/enrolled`,
        as: `${getLink(goal)}/enrolled`
      }
    ];
    return seeAllLinks;
  }

  return [
    {
      title: goal?.name || '',
      ...getBrowseLink(goal)
    },
    {
      title,
      ...getBrowseLink(goal)
    },
    {
      title: 'Syllabus',
      as: getTopicListLink(goal),
      href: getTopicListHref()
    },
    {
      title: topicGroup.name,
      href: getTopicLink(topicGroup, goal),
      as: getLinkPath()
    }
  ];
};

const getSavedTag = (goal) => {
  if (!goal) return [];
  return [
    {
      title: 'Saved',
      ...getHrefAndAsOfSaved(goal)
    }
  ];
};

export const goBack = () => window.history.back();

const getDriveTags = (ancestors) => {
  if (!ancestors || !Array.isArray(ancestors)) return [];

  return ancestors.map((item) => {
    const isRoot = item?.name === 'root';
    return {
      title: isRoot ? 'Cloud' : item?.name,
      as: isRoot ? '/educator/drive' : `/educator/drive/folder/${item?.uid}`,
      href: isRoot ? '/educator/drive' : '/educator/drive/folder/[itemUID]'
    };
  });
};

const getFreeLiveClassesTags = (goal) => {
  if (!goal) return;
  const as = getLink(goal);
  const href = getLinkHref();
  return [
    {
      title: goal.name,
      as,
      href
    },
    { title: 'Free live classes', as: `${as}/classes`, href: `${href}/classes` }
  ];
};

const breadcrumbs = {
  getClass,
  goBack,
  getPlusTopicsTags,
  getTopologyTags,
  getTopics,
  getCourseTags,
  getTestSeriesTags,
  getSeeAllTags,
  getFreeCourseTags,
  getGoalAndFreeTagsOfFreeTopic,
  getBatchTags,
  getSavedTag,
  getDriveTags,
  getDoubtSolutionsHomeTags,
  getCatalogueQuetionsHomeTag,
  getCatalogueDetailsHomeTags,
  getPlatformSeeAllTags,
  getPlatformBatchTopicsTags,
  getEducatorTag,
  getYoutubeLessonTags,
  getYoutubeCourseTags,
  getFreeLiveClassesTags
};

export default breadcrumbs;
